module.exports = __webpack_public_path__ + "img/percentage.5ac4fcc.png";